import type { ReactElement } from "react"
import { useParams } from "react-router"
import { PlayerPage } from "~/features/player/components/PlayerPage"
import { useStudyDetail } from "../api/useStudyDetail"

/**
 * Playback for a study session. Reuses `useStudyDetail`, so arriving from the
 * detail page is a cache hit and the player starts without a second round trip.
 */
export const StudyPlayerPage = (): ReactElement => {
  const { id, sessionId } = useParams()
  const detail = useStudyDetail(id)

  return (
    <PlayerPage
      detail={detail}
      sessionId={sessionId}
      detailHref={`/study/${id ?? ""}`}
      sessionsTitle="All Sessions"
      notFoundMessage="We couldn't find that study in your library."
      qaHook="study-player"
    />
  )
}
